/**
 * [pug template]
 */
<template lang="pug">
div(:class="{ 'olst-virtualform': true, 'olst-virtualform-min': (isAbtested || isVrAbtested), 'olst-mobile-device': isMobile }")
    div
      ol(v-if="!isAbtested && !isVrAbtested")
        li(v-for="field, fieldKey, fieldIndice in filterRecipeFields", v-if="fieldIsNotHidden(fieldKey)", :id="fieldKey", :class="abTestHiddenFields(fieldKey) ? 'olst-hidden' : ''")
          .olst-base-field
            component(:is="renderingUnitToLoad(field, fieldKey)", :mint="mint", :version="version", :productReference="productReference", :fieldRef='fieldKey', :field='field', :cc_value='fieldValueInCC(fieldKey)', v-on:field-changed="fieldHasChanged", :uom="uom")
      div(v-if="isAbtested")
        div(v-for="(filterRecipeFieldsItems, index) in filterRecipeGroupedFields()")
          .accordion(:class="(filterRecipeFieldsItems.accordion.open === true) ? 'open' : 'close'",)
            label.grouped-fields-title(v-html="(index + 1) + '. ' + filterRecipeFieldsItems.label", :for="filterRecipeFieldsItems.items[0].fieldKey", v-on:click="accordionToggle(filterRecipeFieldsItems.key)")
            label.color-picker-summary-value-error.fp-error--excl(v-html="colorPickerErrorSummary" v-if="filterRecipeFieldsItems.key === 'COLORIS' && filterRecipeFieldsItems.accordion.open && colorPickerHasError()")
            .accordion-switch(:class="(filterRecipeFieldsItems.accordion.open === true) ? 'open' : 'close'", v-text="(filterRecipeFieldsItems.accordion.open === true) ? 'Fermer' : 'Modifier'", v-on:click="accordionToggle(filterRecipeFieldsItems.key)")
            //-
            .olst-base-field-closed.color-picker-summary-color-container(v-if="filterRecipeFieldsItems.key === 'COLORIS'", v-on:click="accordionToggle(filterRecipeFieldsItems.key)")
              .color-picker-summary-color(v-if="colorPictureStyleBackground(getRelatedColorPicture('CH-143_coloris-1', cc.config_1.prefilled_values['CH-143_coloris-1']))")
                .round-color-img(v-if="colorPictureStyleBackground(getRelatedColorPicture('CH-143_coloris-1', cc.config_1.prefilled_values['CH-143_coloris-1']))" v-bind:style="{ 'background': colorPictureStyleBackground(getRelatedColorPicture('CH-143_coloris-1', cc.config_1.prefilled_values['CH-143_coloris-1']))}")
                .round-color-img(v-if="colorPictureStyleBackground(getRelatedColorPicture('CH-144_coloris-2', cc.config_1.prefilled_values['CH-144_coloris-2']))" v-bind:style="{ 'background': colorPictureStyleBackground(getRelatedColorPicture('CH-144_coloris-2', cc.config_1.prefilled_values['CH-144_coloris-2']))}")
                .round-color-img(v-if="colorPictureStyleBackground(getRelatedColorPicture('CH-145_coloris-3', cc.config_1.prefilled_values['CH-145_coloris-3']))" v-bind:style="{ 'background': colorPictureStyleBackground(getRelatedColorPicture('CH-145_coloris-3', cc.config_1.prefilled_values['CH-145_coloris-3']))}")
              .color-picker-summary-text
                .color-picker-summary
                  label.color-picker-summary-title(v-text="'Toile : '", v-if="humanized['Type de toile'] || humanized['Gamme Client']" )
                  label.color-picker-summary-value(v-text="humanized['Type de toile'] || humanized['Gamme Client']")
                .color-picker-summary
                  label.color-picker-summary-title(v-text="'Coloris : '")
                  label.color-picker-summary-value(v-for="field in groupedFieldSummary(filterRecipeFieldsItems.key)" v-text="field.value")
                  label.color-picker-summary-value-error.fp-error--excl(v-html="colorPickerErrorSummary"  v-if="colorPickerHasError()")
            //-
            .olst-base-field-closed(v-if="filterRecipeFieldsItems.key !== 'COLORIS'", v-on:click="accordionToggle(filterRecipeFieldsItems.key)")
              .olst-base-field-closed-summary-item(v-for="field in groupedFieldSummary(filterRecipeFieldsItems.key)")
                label.olst-base-field-closed-summary-item-label(v-text="field.label")
                label.olst-base-field-closed-summary-item-value(v-text="field.value")
                label.olst-base-field-closed-summary-item-error.fp-error--excl(v-if="field.error", v-text="field.error")
            //-
            .olst-base-multi-field(v-if="filterRecipeFieldsItems.key === 'DIMENSIONSDUSTORE'")
              dimensions-field-widget(
                :cc="cc",
                :mint="mint",
                :version="version",
                :productReference="productReference",
                :cc_value='fieldValueInCC(fieldKey)',
                :fieldHasChanged="fieldHasChanged"
                v-on:field-changed="fieldHasChanged",
                :uom="uom"
                :widthField="getWidthField"
                :heightField="getHeightField"
                :widthFieldRef="getDimInfo(productReference).widthFieldRef"
                :heightFieldRef="getDimInfo(productReference).heightFieldRef"
                :widthFieldLabel="getDimInfo(productReference).widthLabel"
                :widthFieldSubtitle="getDimInfo(productReference).widthSubtitle"
                :heightFieldLabel="getDimInfo(productReference).heightLabel"
                :heightFieldSubtitle="getDimInfo(productReference).heightSubtitle"
                :docLink="getDimInfo(productReference).docLink"
              )
            //-
            .olst-base-multi-field(v-if="filterRecipeFieldsItems.key === 'MECANISME'")
              .olst-base-field
                rail-field-widget(v-on:change-rail-color-type="caliWidgetRailChanged", :cc="cc", :railTypeField="getRailTypeField", :railColorField="getRailColorField")
            //-
            .olst-base-multi-field(v-if="filterRecipeFieldsItems.key === 'COLORIS'")
              color-picker-field-widget(
                :cc="cc",
                :mint="mint",
                :version="version",
                :productReference="productReference",
                :cc_value='fieldValueInCC(fieldKey)',
                :uom="uom",
                :filter="getFilterField",
                :colorisA="getColorisAField",
                :colorisB="getColorisBField",
                :colorisC="getColorisCField",
                :totalColorVariation="getTotalColorVariationField",
                v-on:field-changed="fieldHasChanged"
              )
            //-
            div(v-for="field in filterRecipeFieldsItems.items", v-if="fieldIsNotHidden(field.fieldKey) && filterRecipeFieldsItems.key !== 'MECANISME' && filterRecipeFieldsItems.key !== 'DIMENSIONSDUSTORE' && filterRecipeFieldsItems.key !== 'COLORIS'")
              .olst-base-field
                component(:is="renderingUnitToLoad(field, field.fieldKey)", :mint="mint", :version="version", :productReference="productReference", :fieldRef='field.fieldKey', :field='field', :cc_value='fieldValueInCC(field.fieldKey)', v-on:field-changed="fieldHasChanged", :uom="uom")
          .bloc-separator(v-if="filterRecipeGroupedFields().length !== index + 1")
      div(v-if="isVrAbtested")
        div(v-for="(filterRecipeFieldsItems, index) in VoletRoulantFilterRecipeGroupedFields()", :id="filterRecipeFieldsItems.key", :class="{'olst-hidden': isHiddenGroup(filterRecipeFieldsItems.key)}")
          .accordion(:class="{'open': (filterRecipeFieldsItems.accordion.open === true), 'close': (filterRecipeFieldsItems.accordion.open !== true), 'olst-hidden': (filterRecipeFieldsItems.hidden === true)}")
            label.grouped-fields-title(v-html="(index + 1) + '. ' + filterRecipeFieldsItems.label", :for="filterRecipeFieldsItems.items[0].fieldKey", v-on:click="accordionVrToggle(filterRecipeFieldsItems.key)")
            label.color-picker-summary-value-error.fp-error--excl(v-html="vrColorPickerErrorSummary" v-if="filterRecipeFieldsItems.key === 'COLORIS' && filterRecipeFieldsItems.accordion.open && vrColorPickerHasError()")
            .accordion-switch(:class="(filterRecipeFieldsItems.accordion.open === true) ? 'open' : 'close'", v-text="(filterRecipeFieldsItems.accordion.open === true) ? 'Fermer' : 'Modifier'", v-on:click="accordionVrToggle(filterRecipeFieldsItems.key)")
            .olst-base-field-closed.color-picker-summary-color-container(v-if="filterRecipeFieldsItems.key === 'COLORIS'", v-on:click="accordionVrToggle(filterRecipeFieldsItems.key)")
              .color-picker-summary-color(v-if="colorPictureStyleBackground(getRelatedColorPicture('CH-461_coloris', cc.config_1.prefilled_values['CH-461_coloris']))")
                .round-color-img(v-if="colorPictureStyleBackground(getRelatedColorPicture('CH-461_coloris', cc.config_1.prefilled_values['CH-461_coloris']))" v-bind:style="{ 'background': colorPictureStyleBackground(getRelatedColorPicture('CH-461_coloris', cc.config_1.prefilled_values['CH-461_coloris']))}")
              .color-picker-summary-text
                .color-picker-summary
                  label.color-picker-summary-title(v-text="'Matière : '")
                  label.color-picker-summary-value(v-text="humanized['Matière']")
                .color-picker-summary
                  label.color-picker-summary-title(v-text="'Coloris : '")
                  label.color-picker-summary-value(v-text="humanized['Coloris']")
                  label.color-picker-summary-value-error.fp-error--excl(v-html="vrColorPickerErrorSummary"  v-if="vrColorPickerHasError()")
            //-
            //- Coloris
            .olst-base-field-closed(v-if="filterRecipeFieldsItems.key !== 'COLORIS'", v-on:click="accordionVrToggle(filterRecipeFieldsItems.key)")
              .olst-base-field-closed-summary-item(v-for="field in groupedFieldSummary(filterRecipeFieldsItems.key, productReference)")
                label.olst-base-field-closed-summary-item-label(v-if="fieldIsVisible(field.key)", v-text="field.label")
                label.olst-base-field-closed-summary-item-value(v-if="fieldIsVisible(field.key)", v-text="field.value")
                label.olst-base-field-closed-summary-item-error.fp-error--excl(v-if="field.error", v-text="field.error")
            //- Dimensions
            .olst-base-multi-field(v-if="filterRecipeFieldsItems.key === 'DIMENSIONSDUVOLET'")
              dimensions-field-widget(
                :cc="cc",
                :mint="mint",
                :version="version",
                :productReference="productReference",
                :cc_value='fieldValueInCC(fieldKey)',
                :fieldHasChanged="fieldHasChanged"
                :uom="uom"
                :widthField="getVrWidthField"
                :heightField="getVrHeightField"
                :widthFieldRef="getDimInfo(productReference).widthFieldRef"
                :heightFieldRef="getDimInfo(productReference).heightFieldRef"
                :widthFieldLabel="getDimInfo(productReference).widthLabel"
                :widthFieldSubtitle="getDimInfo(productReference).widthSubtitle"
                :heightFieldLabel="getDimInfo(productReference).heightLabel"
                :heightFieldSubtitle="getDimInfo(productReference).heightSubtitle"
                :docLink="getDimInfo(productReference).docLink"
                v-on:field-changed="fieldHasChanged"
              )
            .olst-base-multi-field(v-if="filterRecipeFieldsItems.key === 'COLORIS'")
              vr-color-picker-field-widget(
                :cc="cc",
                :mint="mint",
                :version="version",
                :productReference="productReference",
                :cc_value='fieldValueInCC(fieldKey)',
                :uom="uom",
                :colorisA="getVrColorisAField",
                :validation="validation",
                v-on:field-changed="fieldHasChanged"
              )
            div(v-for="field in filterRecipeFieldsItems.items", v-if="fieldIsNotHidden(field.fieldKey) && filterRecipeFieldsItems.key !== 'DIMENSIONSDUVOLET' && filterRecipeFieldsItems.key !== 'COLORIS'")
              .olst-base-field(:class="field.fieldKey")
                component(:is="renderingUnitToLoad(field, field.fieldKey)", :mint="mint", :version="version", :productReference="productReference", :validation='validation', :cc='cc', :fieldRef='field.fieldKey', :field='field', :cc_value='fieldValueInCC(field.fieldKey)', v-on:field-changed="fieldHasChanged", :uom="uom")
          .bloc-separator(v-if="VoletRoulantFilterRecipeGroupedFields().length !== index + 1 && VoletRoulantFilterRecipeGroupedFields().length !== index + 2")
        //- Abtest display all the time info msg
        .olst-field-validation-picture-field-alt(v-for="message, key in validation.info['CH-467_anti-vol']")
          div(v-text="message").olst-field-infos.olst-field-info
</template>
/**
 * [javascript application]
 */
<script>
import common from '../../lib/common/common.js'
import fr from '../../config/translationFr'
import clientConfig from '../../config/global'
import SelectionPictureHandleSide from '../rendering_unit/abTest/SelectionPictureHandleSide'
import SelectionPictureFixation from '../rendering_unit/abTest/SelectionPictureFixation'
import SelectionPictureBandeSize from '../rendering_unit/abTest/SelectionPictureBandeSize'
import SelectionPictureBandeFold from '../rendering_unit/abTest/SelectionPictureBandeFold'
import SelectionPictureBox from '../rendering_unit/abTest/volet-roulant/SelectionPictureBox'
import SelectionPictureInstallation from '../rendering_unit/abTest/volet-roulant/SelectionPictureInstallation'
import SelectionPictureOptSecu from '../rendering_unit/abTest/volet-roulant/SelectionPictureOptSecu'
import SelectionPictureCommande from '../rendering_unit/abTest/volet-roulant/SelectionPictureCommande'
import SelectionPictureOptCommande from '../rendering_unit/abTest/volet-roulant/SelectionPictureOptCommande'
import SelectionPictureCoteCommande from '../rendering_unit/abTest/volet-roulant/SelectionPictureCoteCommande'
import Selection from '../rendering_unit/Selection'
import lodash from 'lodash'

export default {
  name: 'virtual-form',
  props: {
    recipe: {
      type: Object,
      default: {}
    },
    bundle: {
      type: Object,
      default: {}
    },
    uom: {
      type: String,
      default: 'cm'
    },
    version: {
      type: String,
      default: 'default'
    },
    mint: {
      type: Number,
      default: 0
    },
    debug: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      PRD_14: 'PRD-14_store-californien',
      PRD_44: 'PRD-44_volet-roulant-rnovation-new',
      B_VERSION: 'B',
      cc: {},
      timer: {},
      fields: {},
      validation: {},
      humanized: {},
      linkedFields: {},
      formCaliFieldsGroupe: [
        {
          key: 'INSTALLATION',
          label: fr.abTest.prd14.variationB.fieldsGroup.INSTALLATION,
          accordion: {
            open: false
          },
          items: []
        },
        {
          key: 'LARGEURDEBANDES',
          label: fr.abTest.prd14.variationB.fieldsGroup.LARGEURDEBANDES,
          accordion: {
            open: false
          },
          items: []
        },
        {
          key: 'DIMENSIONSDUSTORE',
          label: fr.abTest.prd14.variationB.fieldsGroup.DIMENSIONSDUSTORE,
          accordion: {
            open: true
          },
          items: []
        },
        {
          key: 'COLORIS',
          label: fr.abTest.prd14.variationB.fieldsGroup.COLORIS,
          accordion: {
            open: true
          },
          items: []
        },
        {
          key: 'MECANISME',
          label: fr.abTest.prd14.variationB.fieldsGroup.MECANISME,
          accordion: {
            open: false
          },
          items: []
        }
        // },
        // {
        //   key: '_NOTFOUND',
        //   label: 'NOT FOUND',
        //   accordion: {
        //     open: false
        //   },
        //   items: []
        // }
      ],
      formVoletRoulantFieldsGroupe: [
        {
          key: 'DIMENSIONSDUVOLET',
          label: fr.abTest.prd44.variationB.fieldsGroup.DIMENSIONS,
          accordion: {
            open: true
          },
          items: []
        },
        {
          key: 'COLORIS',
          label: fr.abTest.prd44.variationB.fieldsGroup.COLORIS,
          accordion: {
            open: true
          },
          items: []
        },
        {
          key: 'COFFRE',
          label: fr.abTest.prd44.variationB.fieldsGroup.COFFRE,
          accordion: {
            open: false
          },
          items: []
        },
        {
          key: 'INSTALLATION',
          label: fr.abTest.prd44.variationB.fieldsGroup.INSTALLATION,
          accordion: {
            open: false
          },
          items: []
        },
        {
          key: 'COMMANDE',
          label: fr.abTest.prd44.variationB.fieldsGroup.COMMANDE,
          accordion: {
            open: true
          },
          items: []
        },
        {
          key: 'OPTSECU',
          label: fr.abTest.prd44.variationB.fieldsGroup.OPTSECU,
          accordion: {
            open: false
          },
          items: []
        },
        {
          key: 'ABTEST',
          label: fr.abTest.prd44.variationB.fieldsGroup.ABTEST,
          accordion: {
            open: true
          },
          hidden: true,
          items: []
        }
      ]
    }
  },
  components: clientConfig.rendering_units,
  /** **************************************************************************
   * ***************************************************************************
   * Computed methods
   */
  computed: {
    colorPickerErrorSummary: function () {
      const config = this.bundle.config_1 || {}
      const errors = (((config.validation || {}).errors || [])['CH-143_coloris-1'] || [])
      let msg = ''
      switch (this.cc.config_1.prefilled_values['CH-142_type-de-store']) {
        case 'OPT-231_store-1-couleur':
        case 'OPT-232_store-2-couleurs':
        case 'OPT-233_store-3-couleurs':
          msg = errors.join('<br/>')
      }
      return msg !== '' ? msg : fr.abTest.prd14.variationB.fields.colorPicker.noColorsSelected
    },
    vrColorPickerErrorSummary: function () {
      const errors = ((this.validation || {}).errors || [])['CH-461_coloris'] || []
      return errors.join('<br/>')
    },
    getWidthField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-136_largeur'], {chKey: 'CH-136_largeur'})
    },
    getHeightField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-137_hauteur'], {chKey: 'CH-137_hauteur'})
    },
    getRailTypeField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-146_type-de-rail'], {chKey: 'CH-146_type-de-rail'})
    },
    getRailColorField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-147_couleur-de-rail-classique'], {chKey: 'CH-147_couleur-de-rail-classique'})
    },
    isAbtested: function () {
      return (this.version === this.B_VERSION && this.productReference === this.PRD_14)
    },
    isVrAbtested: function () {
      return (this.version === this.B_VERSION && this.productReference === this.PRD_44)
    },
    getFilterField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-143_coloris-1'].filters['FIL-9_coloris'], {chKey: 'FIL-9_coloris'})
    },
    getColorisAField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-143_coloris-1'], {chKey: 'CH-143_coloris-1'})
    },
    getColorisBField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-144_coloris-2'], {chKey: 'CH-144_coloris-2'})
    },
    getColorisCField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-145_coloris-3'], {chKey: 'CH-145_coloris-3'})
    },
    getTotalColorVariationField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-142_type-de-store'], {chKey: 'CH-142_type-de-store'})
    },
    productReference: function () {
      if (typeof this.cc.config_1 === 'object') {
        if (typeof this.cc.config_1.product_reference === 'string') {
          return this.cc.config_1.product_reference
        }
      }
      return null
    },
    getVrWidthField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-459_largeur'], {chKey: 'CH-459_largeur'})
    },
    getVrHeightField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-460_hauteur'], {chKey: 'CH-460_hauteur'})
    },
    getCaliDimLabels: function () {
      return Object.assign({},
        {'widthLabel': fr.abTest.prd14.variationB.fields.dimension.width.label},
        {'widthSubtitle': fr.abTest.prd14.variationB.fields.dimension.width.subtitle},
        {'heightLabel': fr.abTest.prd14.variationB.fields.dimension.height.label},
        {'heightSubtitle': fr.abTest.prd14.variationB.fields.dimension.height.subtitle}
      )
    },
    getVrDimLabels: function (tst) {
      return Object.assign({},
        {'widthLabel': fr.abTest.prd44.variationB.fields.dimension.width.label},
        {'widthSubtitle': fr.abTest.prd44.variationB.fields.dimension.width.subtitle},
        {'heightLabel': fr.abTest.prd44.variationB.fields.dimension.height.label},
        {'heightSubtitle': fr.abTest.prd44.variationB.fields.dimension.height.subtitle}
      )
    },
    getVrColorisAField: function () {
      return Object.assign({}, this.filterRecipeFieldsMethod()['CH-461_coloris'], {chKey: 'CH-461_coloris'})
    },
    /**
     * Retourne un objet avec les fields de la recipe triés par leurs "weight"
     * @return {object} fields sort by weight
     */
    filterRecipeFields: function () {
      return this.filterRecipeFieldsMethod()
    },
    /**
     * AB/test Return cc
     */
    getCc: function () {
      return this.cc
    }
  },
  /** **************************************************************************
   * ***************************************************************************
   * Watch methods
   */
  watch: {
    /**
     * Met à jour la validation
     * @param  {object} newValue
     * @param  {object} oldValue
     */
    bundle: function (newValue, oldValue) {
      if (typeof newValue.config_1.humanized !== 'undefined') {
        this.humanized = newValue.config_1.humanized
      }
      if (typeof newValue.config_1.validation !== 'undefined') {
        this.validation = newValue.config_1.validation
        this.cleanValidationInField()
        this.ventilateValidationInFields(this.validation)
        this.ventilateFieldValueHiddenDisable(this.validation)
        let beforeCC = JSON.stringify(this.cc)
        this.cc = this.cleanCc(this.cc)
        if (beforeCC !== JSON.stringify(this.cc)) {
          this.$emit('cc-changed', this.convertCcToUom(common.cloneDataObject(this.cc)))
        }
      }
    },
    /**
     * Recipe watcher
     * @param  {object} newValue
     * @param  {object} oldValue
     */
    recipe: function (newValue, oldValue) {
      this.fields = newValue.fields
      this.mapLinkedFields(newValue.fields)
      if (typeof newValue.humanized !== 'undefined') {
        this.humanized = newValue.humanized
      }
      if (typeof newValue.validation !== 'undefined') {
        this.validation = newValue.validation
        this.cleanValidationInField()
        this.ventilateValidationInFields(this.validation)
        this.ventilateFieldValueHiddenDisable(this.validation)
      }
      this.buildNewCc(newValue)
    },
    /**
     * Cc watcher
     * @param  {object} newValue
     * @param  {object} oldValue
     */
    cc: function (newValue, oldValue) {
      var vue = this
      var newCC = this.convertCcToUom(common.cloneDataObject(newValue))
      newCC = this.cleanCc(newCC)
      clearTimeout(this.timer)
      this.timer = setTimeout(function () {
        vue.$emit('cc-changed', newCC)
      }, 500)
    }
  },
  /** **************************************************************************
   * ***************************************************************************
   * Component methods
   */
  methods: {
    getDimInfo: function (prd) {
      switch (prd) {
        case this.PRD_44:
          return Object.assign({},
            {'widthFieldRef': 'CH-459_largeur'},
            {'heightFieldRef': 'CH-460_hauteur'},
            {'widthLabel': fr.abTest.prd44.variationB.fields.dimension.width.label},
            {'widthSubtitle': fr.abTest.prd44.variationB.fields.dimension.width.subtitle},
            {'heightLabel': fr.abTest.prd44.variationB.fields.dimension.height.label},
            {'heightSubtitle': fr.abTest.prd44.variationB.fields.dimension.height.subtitle},
            {'docLink': 'https://cdn.stores-discount.com/pdf_stores_discount/notice-prise-de-mesure-volet-roulant-renovation.pdf'}
          )
        default:
          return Object.assign({},
            {'widthFieldRef': 'CH-136_largeur'},
            {'heightFieldRef': 'CH-137_hauteur'},
            {'widthLabel': fr.abTest.prd14.variationB.fields.dimension.width.label},
            {'widthSubtitle': fr.abTest.prd14.variationB.fields.dimension.width.subtitle},
            {'heightLabel': fr.abTest.prd14.variationB.fields.dimension.height.label},
            {'heightSubtitle': fr.abTest.prd14.variationB.fields.dimension.height.subtitle},
            {'docLink': 'https://cdn.stores-discount.com/pdf_stores_discount/stores-californien/notice-prise-de-mesure-stores-californiens.pdf'}
          )
      }
    },
    colorPickerHasError: function () {
      switch (this.cc.config_1.prefilled_values['CH-142_type-de-store']) {
        case 'OPT-231_store-1-couleur':
          return !(this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-143_coloris-1', this.cc.config_1.prefilled_values['CH-143_coloris-1'])))
        case 'OPT-232_store-2-couleurs':
          return !(
            this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-143_coloris-1', this.cc.config_1.prefilled_values['CH-143_coloris-1'])) &&
            this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-144_coloris-2', this.cc.config_1.prefilled_values['CH-144_coloris-2']))
          )
        case 'OPT-233_store-3-couleurs':
          return !(
            this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-143_coloris-1', this.cc.config_1.prefilled_values['CH-143_coloris-1'])) &&
            this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-144_coloris-2', this.cc.config_1.prefilled_values['CH-144_coloris-2'])) &&
            this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-145_coloris-3', this.cc.config_1.prefilled_values['CH-145_coloris-3']))
          )
      }
      return false
    },
    vrColorPickerHasError: function () {
      return ((this.validation || {}).errors || [])['CH-461_coloris'] || false
    },
    colorPictureStyleBackground: function (url) {
      if (url) {
        return `url(${url}) no-repeat -3px -3px`
      } else {
        return false
      }
    },
    getRelatedColorPicture: function (fieldKey, colorKey) {
      if (this.recipe.fields) {
        const field = this.recipe.fields[fieldKey]
        if (field) {
          const color = this.recipe.fields[fieldKey].values[colorKey]
          if (color) {
            return color.imageZoomUrl
          }
        }
      }
      return false
    },
    caliWidgetRailChanged: function (event) {
      Object.keys(event).forEach(key => {
        this.fieldHasChanged({
          [key]: {
            newValue: event[key]
          }
        })
      })
    },
    filterRecipeGroupedFields: function () {
      const rawResult = this.filterRecipeFieldsMethod()
      const formCaliFieldsGroupeHydrated = Object.keys(rawResult).reduce((reduced, key) => {
        let tmpItem = null
        switch (key) {
          case 'CH-151_type-douverture':
            tmpItem = rawResult[key]
            tmpItem.weight = 102
            tmpItem.fieldKey = key
            reduced[0].items[reduced[0].items.length] = tmpItem
            break
          case 'CH-152_ct-de-commande':
            tmpItem = rawResult[key]
            tmpItem.weight = 103
            tmpItem.fieldKey = key
            reduced[0].items[reduced[0].items.length] = tmpItem
            break
          case 'CH-154_fixations-rail-classique':
            tmpItem = rawResult[key]
            tmpItem.weight = 101
            tmpItem.fieldKey = key
            reduced[0].items[reduced[0].items.length] = tmpItem
            break
          //
          case 'CH-138_largeur-de-bandes':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            reduced[1].items[reduced[1].items.length] = tmpItem
            break
          //
          case 'CH-136_largeur':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 101
            reduced[2].items[reduced[2].items.length] = tmpItem
            break
          case 'CH-137_hauteur':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 102
            reduced[2].items[reduced[2].items.length] = tmpItem
            break
          //
          // case 'CH-140_type-de-toile':
          // case 'CH-142_type-de-store':
          case 'CH-143_coloris-1':
          case 'CH-144_coloris-2':
          case 'CH-145_coloris-3':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            reduced[3].items[reduced[3].items.length] = tmpItem
            break
          //
          case 'CH-146_type-de-rail':
          case 'CH-147_couleur-de-rail-classique':
          // case 'CH-149_couleur-de-commandes':
          // case 'CH-150_couleur-plaques-et-chanette-basse':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            reduced[4].items[reduced[4].items.length] = tmpItem
            break
          default:
            // tmpItem = rawResult[key]
            // tmpItem.fieldKey = key
            // reduced[5].items[reduced[5].items.length] = tmpItem
            break
        }
        return reduced
      }, common.cloneDataObject(this.formCaliFieldsGroupe))
      formCaliFieldsGroupeHydrated[0].items = lodash.orderBy(formCaliFieldsGroupeHydrated[0].items, 'weight')
      const result = formCaliFieldsGroupeHydrated.map((groupe, pos) => {
        groupe.items = lodash.orderBy(groupe.items, 'weight')
        return groupe
      })
      // this.formCaliFieldsGroupe = result
      return result
    },
    VoletRoulantFilterRecipeGroupedFields: function () {
      const rawResult = this.filterRecipeFieldsMethod()
      const formVrFieldsGroupeHydrated = Object.keys(rawResult).reduce((reduced, key) => {
        let tmpItem = null
        switch (key) {
          case 'CH-459_largeur':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 100
            reduced[0].items[reduced[0].items.length] = tmpItem
            break
          case 'CH-460_hauteur':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 101
            reduced[0].items[reduced[0].items.length] = tmpItem
            break
          case 'CH-461_coloris':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 102
            reduced[1].items[reduced[1].items.length] = tmpItem
            break
          case 'CH-457_type-de-coffre':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 103
            reduced[2].items[reduced[2].items.length] = tmpItem
            break
          case 'CH-465_type-de-pose':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 104
            reduced[3].items[reduced[3].items.length] = tmpItem
            break
          case 'CH-469_commande':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 105
            reduced[4].items[reduced[4].items.length] = tmpItem
            break
          case 'CH-470_option-de-commande':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 106
            reduced[4].items[reduced[4].items.length] = tmpItem
            break
          case 'CH-464_ct-de-commande':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 107
            reduced[4].items[reduced[4].items.length] = tmpItem
            break
          case 'CH-467_anti-vol':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 108
            reduced[5].items[reduced[5].items.length] = tmpItem
            break
          // ======= TEMPO
          case 'CH-616_filtre-commande':
          case 'CH-622_filtre-commande':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 109
            reduced[6].items[reduced[6].items.length] = tmpItem
            break
          case 'CH-614_version-fiche-produit':
          case 'CH-620_version-fiche-produit':
            tmpItem = rawResult[key]
            tmpItem.fieldKey = key
            tmpItem.weight = 110
            reduced[6].items[reduced[6].items.length] = tmpItem
            break
          default:
            // tmpItem = rawResult[key]
            // tmpItem.fieldKey = key
            // reduced[5].items[reduced[5].items.length] = tmpItem
            break
        }
        return reduced
      }, common.cloneDataObject(this.formVoletRoulantFieldsGroupe))
      formVrFieldsGroupeHydrated[0].items = lodash.orderBy(formVrFieldsGroupeHydrated[0].items, 'weight')
      const result = formVrFieldsGroupeHydrated.map((groupe, pos) => {
        groupe.items = lodash.orderBy(groupe.items, 'weight')
        return groupe
      })
      return result
    },
    groupedFieldSummary: function (groupedFieldKey, prdRef) {
      const ccItems = (prdRef === this.PRD_44) ? this.VoletRoulantFilterRecipeGroupedFields() : this.filterRecipeGroupedFields()
      const fields = ccItems.find(item => item.key === groupedFieldKey).items
      return fields.reduce((reduced, field) => {
        if (typeof this.humanized[field.label] !== 'undefined') {
          let relatedFieldError = ''
          if (typeof this.validation !== 'undefined') {
            if (typeof this.validation.errors !== 'undefined') {
              relatedFieldError = [...this.validation.errors[field.fieldKey] || []].join('')
            }
          }
          let value = this.humanized[field.label]
          if (field.fieldKey === 'CH-136_largeur' || field.fieldKey === 'CH-137_hauteur') {
            value = `${common.toCm(parseInt(this.humanized[field.label]), 'mm')} cm`
          }
          if (field.fieldKey === 'CH-459_largeur' || field.fieldKey === 'CH-460_hauteur') {
            value = `${this.humanized[field.label]} mm`
          }
          // Todo optimize this
          if (field.fieldKey === 'CH-464_ct-de-commande' && (this.cc.config_1.prefilled_values['CH-616_filtre-commande'] === 'OPT-2426_motorise-radio-commande' || this.cc.config_1.prefilled_values['CH-622_filtre-commande'] === 'OPT-2439_motorise-radio-commande')) {
            field.label = 'Sortie électrique (vue de l\'intérieur)'
            this.humanized[field.label] = 'Sortie électrique (vue de l\'intérieur)'
            value = value.includes('gauche') ? 'à gauche' : 'à droite'
          }
          reduced.push({
            key: field.fieldKey,
            label: `${field.label} : `,
            value: value,
            error: relatedFieldError
          })
        }
        return reduced
      }, [])
    },
    accordionToggle: function (key) {
      const newformCaliFieldsGroupe = common.cloneDataObject(this.formCaliFieldsGroupe)
      newformCaliFieldsGroupe.forEach((item, pos) => {
        if (item.key === key) {
          newformCaliFieldsGroupe[pos].accordion.open = !newformCaliFieldsGroupe[pos].accordion.open
        }
      })
      this.formCaliFieldsGroupe = newformCaliFieldsGroupe
    },
    accordionVrToggle: function (key) {
      const newformVoletRoulantFieldsGroupe = common.cloneDataObject(this.formVoletRoulantFieldsGroupe)
      newformVoletRoulantFieldsGroupe.forEach((item, pos) => {
        if (item.key === key) {
          newformVoletRoulantFieldsGroupe[pos].accordion.open = !newformVoletRoulantFieldsGroupe[pos].accordion.open
        }
      })
      this.formVoletRoulantFieldsGroupe = newformVoletRoulantFieldsGroupe
    },
    filterRecipeFieldsMethod: function () {
      // Mapping des fields dans un array sous [{key: 'prd', weight: 100}]
      var mapFieldSortedByWeight = []
      let i = 0
      for (var fieldKey in this.fields) {
        if (typeof this.fields[fieldKey].accordion === 'undefined') {
          this.fields[fieldKey].accordion = {
            open: i === 0
            // open: false
          }
        }
        var mapField = {}
        mapField.key = fieldKey
        mapField.weight = this.fields[fieldKey].weight
        mapFieldSortedByWeight.push(mapField)
        i++
      }
      // Tri de l'array "map" par les weight des fields
      mapFieldSortedByWeight = lodash.sortBy(mapFieldSortedByWeight, 'weight')
      // Création de la liste des Fields Mappé par l'array "map"
      var fieldsSortedByWeight = {}
      for (var mapFieldPos in mapFieldSortedByWeight) {
        fieldKey = mapFieldSortedByWeight[mapFieldPos].key
        fieldsSortedByWeight[fieldKey] = Object.assign({}, this.fields[fieldKey])
      }
      return fieldsSortedByWeight
    },
    /**
     * change la valeur des champ size en mm
     * Cette fonction est utile juste pour le retour de l'API externe
     * @param  {object} cc
     * @return {object}    cc
     */
    renderingUnitToLoad: function (field, fieldKey) {
      if (this.version === this.B_VERSION && (this.productReference === this.PRD_14 || this.productReference === this.PRD_44)) {
        switch (fieldKey) {
          case 'CH-152_ct-de-commande':
            return SelectionPictureHandleSide
          case 'CH-154_fixations-rail-classique':
            return SelectionPictureFixation
          case 'CH-138_largeur-de-bandes':
            return SelectionPictureBandeSize
          case 'CH-151_type-douverture':
            return SelectionPictureBandeFold
          case 'CH-457_type-de-coffre':
            return SelectionPictureBox
          case 'CH-465_type-de-pose':
            return SelectionPictureInstallation
          case 'CH-469_commande':
            return SelectionPictureCommande
          case 'CH-470_option-de-commande':
            return SelectionPictureOptCommande
          case 'CH-464_ct-de-commande':
            return SelectionPictureCoteCommande
          case 'CH-467_anti-vol':
            return SelectionPictureOptSecu
          case 'CH-616_filtre-commande':
          case 'CH-622_filtre-commande':
            return Selection
          case 'CH-614_version-fiche-produit':
          case 'CH-620_version-fiche-produit':
            return Selection
        }
      }
      for (var index in clientConfig.rendering_unit_mapping) {
        if (clientConfig.rendering_unit_mapping[index].name === field.elementType) {
          // Fiche A
          if (fieldKey !== 'CH-616_filtre-commande' && fieldKey !== 'CH-622_filtre-commande') {
            if (this.isMobile && typeof clientConfig.rendering_unit_mapping[index].rendering_unit_mobile !== 'undefined') {
              return clientConfig.rendering_unit_mapping[index].rendering_unit_mobile
            } else {
              return clientConfig.rendering_unit_mapping[index].rendering_unit
            }
          }
        }
      }

      return null
    },
    /**
     * change la valeur des champ size en mm
     * Cette fonction est utile juste pour le retour de l'API externe
     * @param  {object} cc
     * @return {object}    cc
     */
    convertCcToUom: function (cc) {
      for (var fieldKey in cc.config_1.prefilled_values) {
        if (typeof this.fields[fieldKey] !== 'undefined') {
          if (this.fields[fieldKey].elementType === 'size') {
            // Si la prefilled_value est différente de la cc_value
            cc.config_1.prefilled_values[fieldKey] = common.toMm(cc.config_1.prefilled_values[fieldKey], this.uom)
          }
        }
      }
      return cc
    },
    /**
     * Retourne la valeur du champ dans la CC
     * @param  {string} fieldKey
     */
    fieldValueInCC: function (fieldKey) {
      if (this.version !== this.B_VERSION && this.productReference === this.PRD_44) {
        this.cc.config_1.prefilled_values['CH-614_version-fiche-produit'] = 'OPT-2402_classique'
        this.cc.config_1.prefilled_values['CH-620_version-fiche-produit'] = 'OPT-2433_classique' // Prod
        delete this.cc.config_1.prefilled_values['CH-616_filtre-commande']
        delete this.cc.config_1.prefilled_values['CH-622_filtre-commande'] // Prod
      }
      return this.cc.config_1.prefilled_values[fieldKey]
    },
    /**
     * Met à jour la valeur du feild dans la cc
     * @param  {object} cc
     * @param  {object} field
     * @return {cc}       cc
     */
    updateFieldInCC: function (cc, field) {
      var fieldKeyUpdate = Object.keys(field)
      if (typeof field[fieldKeyUpdate] !== 'undefined') {
        cc.config_1.prefilled_values[fieldKeyUpdate] = field[fieldKeyUpdate].newValue
      }
      return cc
    },
    /**
     * Supprime les valeurs de la cc présente dans hidden ou disable values
     * @param  {object} cc
     * @return {object}    cc
     */
    cleanCc: function (cc) {
      var hiddenValues = common.returnAlwaysArray(this.validation.hidden_values)
      var disabledValues = common.returnAlwaysArray(this.validation.disabled_values)
      for (var fieldKey in cc.config_1.prefilled_values) {
        // Gestion des champ liés
        if (typeof this.linkedFields[fieldKey] !== 'undefined') {
          var linkedField = this.linkedFields[fieldKey]
          var linkedFieldValue = cc.config_1.prefilled_values[linkedField]
          // si la linked field value est caché ou désactivé: on vide sa cc
          if (common.arrayContain(hiddenValues, linkedFieldValue) || common.arrayContain(disabledValues, linkedFieldValue)) {
            cc.config_1.prefilled_values[linkedField] = ''
          }
        } else {
          // gestion des fields hidden/disabled
          if (typeof this.fields[fieldKey] !== 'undefined') {
            if (this.fields[fieldKey].elementType === 'material') {
              // Gestion d'un colorPicker caché (Coloris 2 & 3 californien)
              if (common.arrayContain(hiddenValues, fieldKey) || common.arrayContain(disabledValues, fieldKey)) {
                cc.config_1.prefilled_values[fieldKey] = ''
              }
              // Gestion des 'range' de coloris
              var colorKey = cc.config_1.prefilled_values[fieldKey]
              var color = common.returnAlwaysObject(this.fields[fieldKey].values[colorKey])
              var colorRange = color.range
              if (typeof colorRange !== 'undefined') {
                if (common.arrayContain(hiddenValues, colorRange) || common.arrayContain(disabledValues, colorRange)) {
                  cc.config_1.prefilled_values[fieldKey] = ''
                }
              }
            }
          }
        }
      }
      return cc
    },
    /**
     * Supprime les validations ventilées dans les fields
     * @return {object} fields
     */
    cleanValidationInField: function () {
      var clonedFields = common.cloneDataObject(this.fields)
      for (var fieldKey in clonedFields) {
        try {
          delete clonedFields[fieldKey].validation
        } catch (e) {
        }
      }
      this.fields = clonedFields
    },
    /**
     * Ventile la validation dans la recipe (fields)
     * @param  {object} validation
     */
    ventilateValidationInFields: function (validation) {
      // Type de validation
      var clonedFields = common.cloneDataObject(this.fields)
      // Ventile pour chaque type de messages
      var validationMessageTypes = ['errors', 'warning', 'info']
      for (var validationMessageTypeKey in validationMessageTypes) {
        var validationMessageType = validationMessageTypes[validationMessageTypeKey]
        if (typeof validation[validationMessageType] !== 'undefined') {
          for (var messageKey in validation[validationMessageType]) {
            // Ajout des infos de validation dans le field correspondant
            clonedFields[messageKey] = common.initiateObjectPropertyIfUndefined(clonedFields[messageKey], 'validation')
            clonedFields[messageKey]['validation'][validationMessageType] = validation[validationMessageType][messageKey]
          }
        }
      }
      // Ventile pour chaque type d'affichage
      var validationDisplayTypes = ['hidden_values', 'disabled_values']
      for (var validationDisplayTypeKey in validationDisplayTypes) {
        var validationDisplayType = validationDisplayTypes[validationDisplayTypeKey]
        if (typeof validation[validationDisplayType] !== 'undefined') {
          for (var displayKey in validation[validationDisplayType]) {
            // Ajout des types de display dans le field correspondant
            var displayFieldKey = validation[validationDisplayType][displayKey]
            // pour chaque field dans fields
            for (var field in clonedFields) {
              if (displayFieldKey.indexOf(field) > -1) {
                clonedFields[field] = common.initiateObjectPropertyIfUndefined(clonedFields[field], 'validation')
                clonedFields[field]['validation'] = common.initiateArrayPropertyIfUndefined(clonedFields[field]['validation'], validationDisplayType)
                clonedFields[field]['validation'][validationDisplayType].push(displayFieldKey)
              }
            }
          }
        }
      }
      // Met à jour la CC
      this.fields = clonedFields
    },
    /**
     * Ventile la validation des valeur hidden et disabled dans les fields (pour les options, coloris, etc...)
     * @param  {object} validation
     * @return {object}            fields
     */
    ventilateFieldValueHiddenDisable: function (validation) {
      var validationDisplayTypes = ['hidden_values', 'disabled_values']
      var clonedFields = common.cloneDataObject(this.fields)
      for (var fieldKey in clonedFields) {
        // if (clonedFields[fieldKey].elementType === 'option') {
        for (var optKey in clonedFields[fieldKey].values) {
          for (var validationDisplayTypeKey in validationDisplayTypes) {
            var validationDisplayType = validationDisplayTypes[validationDisplayTypeKey]
            var validationValues = common.returnAlwaysArray(validation[validationDisplayType])
            // Ventilation de la validation pour les selections
            if (clonedFields[fieldKey].elementType === 'option') {
              var optValue = clonedFields[fieldKey].values[optKey].value
              if (common.arrayContain(validationValues, optValue)) {
                clonedFields[fieldKey] = common.initiateObjectPropertyIfUndefined(clonedFields[fieldKey], 'validation')
                clonedFields[fieldKey]['validation'] = common.initiateArrayPropertyIfUndefined(clonedFields[fieldKey]['validation'], validationDisplayType)
                clonedFields[fieldKey]['validation'][validationDisplayType].push(optValue)
              }
            }
            // Ventilation de la validation pour les material
            if (clonedFields[fieldKey].elementType === 'material') {
              var rangeValue = clonedFields[fieldKey].values[optKey].range
              if (common.arrayContain(validationValues, rangeValue)) {
                clonedFields[fieldKey] = common.initiateObjectPropertyIfUndefined(clonedFields[fieldKey], 'validation')
                clonedFields[fieldKey]['validation'] = common.initiateArrayPropertyIfUndefined(clonedFields[fieldKey]['validation'], validationDisplayType)
                clonedFields[fieldKey]['validation'][validationDisplayType].push(rangeValue)
              }
            }
          }
        }
        // }
      }
      // Met à jour la CC
      this.fields = clonedFields
    },
    /**
     * Crée une 'map' des 'linkedFields'
     * @param  {object} fields
     * @return {object}        linkedFields
     */
    mapLinkedFields: function (fields) {
      var linkedFields = {}
      for (var fieldKey in fields) {
        var field = fields[fieldKey]
        if (typeof field.linkedField !== 'undefined') {
          linkedFields[fieldKey] = field.linkedField
        }
        // si le champ à des filtres, on les test
        if (typeof field.filters !== 'undefined') {
          for (var filterKey in field.filters) {
            if (typeof field.filters[filterKey].linkedField !== 'undefined') {
              linkedFields[filterKey] = field.filters[filterKey].linkedField
            }
          }
        }
      }
      this.linkedFields = linkedFields
    },
    /**
     * Crée un CC vide
     * @param  {object} recipe
     */
    buildNewCc: function (recipe) {
      // Création de la structure de la CC
      var config = {
        config_1: {
          product_reference: recipe.product_ref,
          prefilled_values: {}
        }
      }
      // Ajout les champs dans les prefilled values
      for (var fieldKey in recipe.fields) {
        if (typeof recipe.fields[fieldKey].defaultVal !== 'undefined') {
          // si le field est un "size", on calcul la valeur avec l'uom
          var defaultValue = recipe.fields[fieldKey].defaultVal
          if (recipe.fields[fieldKey].elementType === 'size') {
            defaultValue = common.convertUomToUom(defaultValue, 'mm', this.uom).toString()
          }
          config.config_1.prefilled_values[fieldKey] = defaultValue
        } else {
          config.config_1.prefilled_values[fieldKey] = ''
        }
        // si le champ à des filtres, on ajoutes les filtres
        if (typeof recipe.fields[fieldKey].filters !== 'undefined') {
          for (var filterKey in recipe.fields[fieldKey].filters) {
            config.config_1.prefilled_values[filterKey] = []
            for (var valueKey in recipe.fields[fieldKey].filters[filterKey].defaultVal) {
              config.config_1.prefilled_values[filterKey].push(valueKey)
            }
          }
        }
      }
      // Mise à jour de la CC
      this.cc = config
    },
    /**
     * Retourne True si le Field doit être affiché
     * @param  {string} fieldRef
     * @return {boolean}
     */
    fieldIsNotHidden: function (fieldRef) {
      if (common.arrayContain(this.validation.hidden_values, fieldRef)) {
        if (this.fields[fieldRef].elementType === 'material') {
          return false
        }
      }
      return true
    },
    /**
     * Linstener, un champ a été modifié
     * @param  {object} field
     */
    fieldHasChanged: function (field) {
      this.cc = this.updateFieldInCC(common.cloneDataObject(this.cc), field)
    },
    show: function (obj) {
      console.log('===> Show ', obj)
    },
    abTestHiddenFields: function (fieldKey) {
      var hiddenFields = ['CH-614_version-fiche-produit', 'CH-616_filtre-commande', 'CH-620_version-fiche-produit', 'CH-622_filtre-commande']
      return hiddenFields.find(function (element) {
        return element === fieldKey
      })
    },
    /**
     * Retourne True si le Field doit être affiché
     * @param  {string} fieldRef
     * @return {boolean}
     */
    fieldIsVisible: function (fieldRef) {
      return !common.arrayContain(this.validation.hidden_values, fieldRef)
    },
    /**
     * Retourne True si le Field doit être affiché
     * @param  {string} fieldRef
     * @return {boolean}
     */
    isHiddenGroup: function (groupKey) {
      if (groupKey === 'OPTSECU' && (this.cc.config_1.prefilled_values['CH-616_filtre-commande'] === 'OPT-2427_motorise-solaire' || this.cc.config_1.prefilled_values['CH-622_filtre-commande'] === 'OPT-2440_motorise-solaire' || this.cc.config_1.prefilled_values['CH-469_commande'] === 'OPT-1221_tirage-direct-avec-verrou')
      ) {
        return true
      }
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// VirtualForm.vue?64835142